import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import router from './router/index'
import config from './firebase_config'
import { userInfo } from 'os';
import moment from 'moment';

firebase.initializeApp(config);
const firebaseDB = firebase.firestore();
firebaseDB.settings({
    timestampsInSnapshots: true
});
Vue.use(Vuex)


//firebase:ログイン状況の通知
firebase.auth().onAuthStateChanged(user => {

    if (user) {
        store.state.isLogin = true;
        store.commit("SetLoginUser", user)
        store.dispatch("GetUserProfileAdditionalInformation")
        return;
    }
    //ログアウト時はデータをリセットしておく
   
    if(user === null)
    {
        // alert(user);
         store.state.isLogin = false;
        store.state.loginUser = null;
        //ユーザー情報をリセット
        store.state.User.displayName = "";
        store.state.User.email = "";
        store.state.User.Introduction = "";
        //データをリセット
         store.state.thinkItems = [];

         //注意：thinkDataのリセットでnullをセットしない！
         //※ログイン時にローディングから先にすすまなくなる
       // store.state.thinkData = null
       store.state.thinkData.title="";
       store.state.thinkData.words=[];
        store.state.activeWord = null

    }

　　　
   


});

const store = new Vuex.Store({
    state: {
        count: 0,
        db: firebaseDB,
        thinkItems: [],
        thinkData: {
            //id:'',
            title: '',
            words: [],
        },
        //ログインユーザーの情報
        User:{
            displayName:"",
            email:"",
            introduction:"",
        },
        loginUser: null,
        isLogin: false,
        activeWord: null,
        Loading: {
            Words: false,
            Thinks: false,
        },
        LimitForSave:{
            thinks:20,
            words:50
        }
    },
    getters: {
        Loading(state) {
            return state.Loading;
        },
        thinkItems(state) {
            return state.thinkItems;
        },
        thinkData(state) {
            return state.thinkData;
        },
        activeWord(state) {
            return state.activeWord;
        },
        loginUser(state) {
            return state.loginUser;
        },
        User(state) {
            return state.User;
        },
        isLogin(state) {
            return state.isLogin;
        },
        LimitForSave(state) {
            return state.LimitForSave;
        },
    },
    //非同期処理を含める
    actions: {
        //====================================
        //アプリのバージョンを取得する
        //====================================
        GetAppVersion({commit,state})
        {
            //promise
            return new Promise((resolve, reject) => {
                var docRef = state.db.collection("AppInfos").doc('AppInfo');
                docRef.get().then(function(doc) {
                    if (doc.exists) {
                        console.log("Document data:"+ doc.data().introduction);
                        var item = {
                            version: doc.data().version,
                        }
                        resolve(item);
                    } else {
                        console.log("No such document!");
                        reject("No such document!")
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                    reject(error)
                });
            })
            //----/End/Promise
        },
        //====================================
        //並び順更新: Thinkデータ
        //====================================
        UpdateThinksOrder({ commit, state }) {
            const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks');
            state.thinkItems.forEach(function (item, index) {
                collection.doc(item.id).update({
                    seq: index,
                });
            })
        },
        //====================================
        //データ取得: ユーザープロファイル：追加情報
        //====================================
        GetUserProfileAdditionalInformation({ commit, state }) {
            
            var user = firebase.auth().currentUser;
            var docRef = state.db.collection("users").doc(user.uid);
            docRef.get().then(function(doc) {
                if (doc.exists) {
                    console.log("Document data:"+ doc.data().introduction);
                    var item = {
                        introduction: doc.data().introduction,
                    }
                    commit('SetUserAdditionalInformation', item);

                    
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });

        },
        //====================================
        //データ取得: Thinkデータ一覧
        //====================================
        GetThinks({ commit, state },{callback}) {

            state.Loading.Thinks = true;
            const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks');
            collection.orderBy("seq").get().then(snapshot => {
                var getItems = [];
                snapshot.forEach(doc => {

                   

                    var item = {
                        id: doc.id,
                        title: doc.data().title,
                        seq: doc.data().seq,
                        uid: doc.data().uid,
                        wordsCount: 0,
                        words: doc.data().words,
                        isEdit: false,
                        created:doc.data().created.seconds,
                    }
                    getItems.push(item);

                    //言葉一覧を取得：ことばの数を取得するため
                    collection.doc(doc.id).collection("words").get().then(snap => {
                        var size = snap.size // will return the collection size

                        item.wordsCount = size
                        // var item = {
                        //     id: doc.id,
                        //     title: doc.data().title,
                        //     seq: doc.data().seq,
                        //     uid: doc.data().uid,
                        //     wordsCount: size,
                        //     words: doc.data().words,
                        //     isEdit: false,
                        //     created:doc.data().created,
                        // }

                        // getItems.push(item);
                    });
                });
                
                commit('SetThinks', getItems);
                state.Loading.Thinks = false;
                callback(true,"")
            });
        },
        //====================================
        //新規追加: Thinkデータ
        //====================================
        AddThink({ commit, state }, { newTitle, index, callback }) {
            var newItem = {
                title: newTitle,
                created: firebase.firestore.FieldValue.serverTimestamp(),
                uid: state.loginUser ? state.loginUser.uid : 'nobody',
                seq: index,
                words: [],
            };
            state.db.collection('thinks').doc(state.loginUser.uid).collection('thinks').add(newItem).then(doc => {
                newItem.id = doc.id;
                newItem.wordsCount = 0;
                newItem.isEdit = false;
                newItem.created = moment(newItem.created).format("X");//unix Timeスタンプに変換※Firestoreから返却される日付型がunixタイムスタンプなため
                commit('AddThink', newItem);
                callback(newItem);

            }).catch(error => {
                alert(error)
            });

        },
       
        //====================================
        //削除: Thinkデータ
        //====================================
        RemoveThink({ commit, dispatch, state }, item) {
            //SPIKE: 現在実験中:use CloudFunction
            // var addMessageFn = firebase.functions().httpsCallable('addMessage');
            // addMessageFn({ text: "にゃんちゃって" })
            //     .then(function(result) {
            //         alert(' success: ' + JSON.stringify(result));
            //     })
            //     .catch(function(err) {
            //         //alert('Delete failed, see console,');
            //         alert(err);
            //     });
            //     return;

            //TODO:wordsサブコレクション無いのドキュメントもすべて削除しなければいけない
            var path = state.db.collection('thinks').doc(state.loginUser.uid).collection('thinks').doc(item.id).path;
            var deleteFn = firebase.functions().httpsCallable('recursiveDelete');
            deleteFn({ path: path })
                .then(function(result) {
                    console.log('Delete success: ' + JSON.stringify(result));
                    commit('RemoveThink', item);
                    dispatch('UpdateThinksOrder');//並び順を更新する
                    item.isLoading = false;
                })
                .catch(function(err) {
                    //alert('Delete failed, see console,');
                    item.isLoading = false;
                    alert(err);
                });
            // state.db.collection('thinks').doc(state.loginUser.uid).collection('thinks').doc(item.id).update({
            //     words:firebase.firestore.FieldValue.delete()
            // })

            // state.db.collection('thinks').doc(state.loginUser.uid).collection('thinks').doc(item.id).delete().then(function () {

            //     commit('RemoveThink', item);
            //     dispatch('UpdateThinksOrder');//並び順を更新する
            //     item.isLoading = false;

            // }).catch(function (error) {
            //     alert(error)
            //     item.isLoading = false;
            // });
        },
        //====================================
        //更新: Thinkデータ　１件
        //====================================
        UpdateThink({ commit, state }, { id,title, callback }) {
            //データの更新
            const collection = state.db.collection('thinks').doc(state.loginUser.uid).collection('thinks');
            collection.doc(id).update({
                title: title
            }).then(function () {
                callback(true,'')
            }).catch(function (error) {
                callback(false,'エラー')
            });;
        },
        //====================================
        //更新: Word　複数件
        //====================================
        UpdateWords({ commit, state }) {
            //データの更新
            const collection = state.db.collection('thinks').doc(state.loginUser.uid).collection('thinks');
            collection.doc(state.thinkData.id).update({
                words: state.thinkData.words
            });
        },
        //====================================
        //データ取得: Word一覧
        //====================================
        GetWords({ commit, state }, {callback} ) {
            state.thinkData.words = [];
            state.Loading.Words = true;
            const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks').doc(state.thinkData.id).collection("words");

            collection.orderBy("index").get().then(snapshot => {
                var getItems = [];
                snapshot.forEach(doc => {
                    var item = {
                        id: doc.id,
                        index: doc.data().index,
                        main: doc.data().main,
                        really: doc.data().really,
                        so: doc.data().so,
                        why: doc.data().why,
                    }
                    getItems.push(item);

                });
                state.thinkData.words = getItems;
                state.Loading.Words = false;
                callback(true,"")
                //commit('SetThinks', getItems);
            });
        },
        //====================================
        //データ取得: Word一覧 ByID
        //====================================
        // GetWordsByThinkId({ commit, state }, { thinkId, callback }) {

        //     const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks').doc(thinkId).collection("words");

        //     collection.orderBy("index").get().then(snapshot => {
        //         var getItems = [];
        //         snapshot.forEach(doc => {
        //             var item = {
        //                 id: doc.id,
        //                 index: doc.data().index,
        //                 main: doc.data().main,
        //                 really: doc.data().really,
        //                 so: doc.data().so,
        //                 why: doc.data().why,
        //             }
        //             getItems.push(item);
        //         });
        //         state.thinkData.id = thinkId;
        //         state.thinkData.words = getItems;
        //         callback(true,"")
        //         //commit('SetThinks', getItems);
        //     });
        // },
        AddWord({ commit, state }, { main, index, callback }) {

            var item = {
                id: "",
                index: index,
                main: main,
                why: "",
                really: "",
                so: ""
            };

            const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks').doc(state.thinkData.id).collection("words");
            collection.add(item).then(doc => {

                item.id = doc.id;
                callback();
                commit('AddWord', item)
            }).catch(errror => {
                alert(error)
            });
        },
        RemoveWord({ commit, dispatch, state }, item) {
            //データの更新
            const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks').doc(state.thinkData.id).collection("words");
            collection.doc(item.id).delete().then(function () {
                commit('RemoveWord', item)
                dispatch('UpdateWordOrder')//並び順を更新
            }).catch(function (error) {
                alert(error)
            });

        },
        UpdateWordMain({ commit, state },item) {
            //データの更新
            const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks').doc(state.thinkData.id).collection("words");
            collection.doc(item.id).update({
                main: item.main,
            });
        },
        UpdateWord({ commit, state }) {
            //データの更新
            const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks').doc(state.thinkData.id).collection("words");
            collection.doc(state.activeWord.id).update({
                really: state.activeWord.really,
                so: state.activeWord.so,
                why: state.activeWord.why,

            });
        },
        UpdateWordOrder({ commit, state }) {
            //データの更新
            const collection = state.db.collection('thinks/' + state.loginUser.uid + '/thinks').doc(state.thinkData.id).collection("words");

            state.thinkData.words.forEach(function (item, index) {
                collection.doc(item.id).update({
                    index: index,
                });
            })
        },
        //===========================
        //ログイン
        //===========================
        Login({ commit, state }, { email, password, callback,redirect = null }) {
            firebase.auth().signInWithEmailAndPassword(email, password)
            .then(function () {
                var user = firebase.auth().currentUser;
                callback(true,"")
                if (redirect === null) {
                    router.push("thinkpage");
                    return
                }
                router.push(redirect);
            })
            .catch(function (error) {
                //エラー時の処理
                let errorCode = error.code;
                let errorMessage = error.message;
                console.log("エラーコード:"+errorCode + "---"+errorMessage)
                callback(false,"メールアドレスかパスワードがまちがっているよ!かくにんしてみてね！")
                return;

            });
        },
        //===========================
        //ユーザー登録
        //===========================
        RegistUser({ commit, state }, { name, email, password,callback }) {
            firebase.auth().createUserWithEmailAndPassword(email, password)
                .then((aaaa) => {
                    //成功したときの処理
                    //alert("uid=$(aaaa.uid)" + aaaa.uid);//uidはいってこない。。

                    var user = firebase.auth().currentUser;
                    //state.loginUser = user;
                    //プロフィール情報を更新
                    user.updateProfile({
                        displayName: name
                    }).then(function () {
                        //alert(user.displayName);
                        // state.loginUser = user;
                        commit("SetLoginUser", user)
                        callback(true,"")
                    }).catch(function (error) {

                    });


                    //usersに追加
                    //Notice: datasource側にも保存
                    //成功、失敗特に担保しない。
                    state.db.collection("users").doc(user.uid).set({
                        userName: name,
                    }, {merge: true}).then(function (docRef) {

                    }).catch(function (error) {
                        console.error("Error adding document: ", error);
                    });

                    // //usersに追加
                    // state.db.collection("users").add({
                    //     uid: user.uid,
                    //     name: name,
                    // }).then(function (docRef) {
                    //     console.log("Document written with ID: ", docRef.id);
                    // }).catch(function (error) {
                    //     console.error("Error adding document: ", error);
                    // });


                    return;
                })
                .catch(function (error) {
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    // [START_EXCLUDE]
                    if (errorCode == 'auth/weak-password') {
                        callback(false,'パスワードが短すぎます'+errorMessage)
                    } else {
                        alert(errorMessage);
                    }
                    console.log(error);
                    return;
                    // [END_EXCLUDE]
                });
        },

        //===========================
        //匿名アカウントを永続アカウントにする
        //===========================
        AnonymousToRegAccount({ commit, state }, { email, password,callback })
        {  
          var credential = firebase.auth.EmailAuthProvider.credential(email, password);
          
          firebase.auth().currentUser.linkAndRetrieveDataWithCredential(credential).then(function(usercred) {
            var user = usercred.user;
            commit("SetLoginUser", user)
            callback(true,"");

          }, function(error) {
            console.log("Error upgrading anonymous account", error);
            callback(false,error);
          });
        },

        //===========================
        //更新: ユーザー情報　＊セキュリティ上重要な情報はのぞく
        //===========================
        UpdateUserProfile({ commit, state }, { name, gender }) {
            var user = firebase.auth().currentUser;
            //プロフィール情報を更新
            user.updateProfile({
                displayName: name
            }).then(function () {
                // alert(user.displayName);
                 state.loginUser = user;
                //commit("SetLoginUser", user)
            }).catch(function (error) {

            }); 
        },
        //===========================
        //更新: ユーザー情報: ユーザー名
        //===========================
        UpdateUserProfileName({ commit, state }, { name, callback }) {
            var user = firebase.auth().currentUser;
            //プロフィール情報を更新
            user.updateProfile({
                displayName: name
            }).then(function () {
                 //state.loginUser.displayName = name;
                commit("SetLoginUser", user)
                callback(true,"");
            }).catch(function (error) {
                callback(false,error);
            }); 

            //Notice: datasource側にも保存
            //成功、失敗特に担保しない。
            state.db.collection("users").doc(user.uid).set({
                userName: name,
            }, {merge: true}).then(function (docRef) {

            }).catch(function (error) {
                console.error("Error adding document: ", error);
            });
        },
        //===========================
        //更新: ユーザー情報: 自己紹介
        //===========================
        UpdateUserProfileIntroduction({ commit, state }, { introduction, callback }) {
            var user = firebase.auth().currentUser;
            state.db.collection("users").doc(user.uid).set({
                introduction: introduction,
            }, {merge: true}).then(function (docRef) {
                //console.log("Document written with ID: ", docRef.id);
                state.User.introduction = introduction;
                callback(true,"");
            }).catch(function (error) {
                console.error("Error adding document: ", error);
                callback(false,error);
            });
        },
        //===========================
        //更新: ユーザー情報：パスワード ＊セキュリティ上重要な情報
        //===========================
        UpdateUserProfilePassword({ commit, state }, { newPassword,password,callback }) {

            var user = firebase.auth().currentUser;
            //パスワードの更新は再認証が必須
            var credential = firebase.auth.EmailAuthProvider.credential(
                user.email,
                password
            );

            user.reauthenticateAndRetrieveDataWithCredential(credential).then(function() {
                // User re-authenticated.
                //パスワードの更新
                user.updatePassword(newPassword).then(function() {
                    // Update successful.
                    callback(true,"");
                }).catch(function(error) {
                    // An error happened.
                    //alert(error)
                    callback(false,error);
                });
                }).catch(function(error) {
                    //alert(error)
                    callback(false,error);
            }); 
        },
        //===========================
        //更新: ユーザーEmail ＊セキュリティ上重要な情報
        //===========================
        UpdateUserProfileEmail({ commit, state }, { newEmail,password,callback }) {


  
            //TODO:未完成
            //
            var user = firebase.auth().currentUser;
            //TODO: Eメールの更新は再認証が必須なので、気軽に変えられない。
            //重要: ユーザーのメールアドレスを設定すというセキュリティ重要な操作を行う場合、ユーザーが最近ログインしている必要があります。
            // ユーザーが最近ログインしていない場合、このような操作を行うと失敗し、エラーになります。
            //このような場合は、ユーザーから新しいログイン認証情報を取得して 
            //reauthenticateWithCredential に渡し、ユーザーを再認証します。
            var credential = firebase.auth.EmailAuthProvider.credential(
                user.email,
                password
                //"sssbbb"
            );

            //TODO: Emailのバリデーション
            user.reauthenticateAndRetrieveDataWithCredential(credential).then(function() {
                // User re-authenticated.
                //Eメールの更新
                user.updateEmail(newEmail).then(function() {
                    // Update successful.
                    state.loginUser = user;

                    callback(true,"");
                }).catch(function(error) {
                    // An error happened.
                    //alert(error)
                    callback(false,error);
                });
                }).catch(function(error) {
                    //alert(error)
                    callback(false,error);
            }); 
        },
    },
    //原則：ミューテーションには「非同期処理」は「含めない」
    mutations: {
        UpdateThinkItems(state, items) {
            state.thinkItems = items;
        },
        //===========================
        //匿名ユーザーのログアウト
        //===========================
        AnonymousLogout(state) {

            var user = firebase.auth().currentUser;
            state.db.collection("users").doc(user.uid).set({
                AnonymousLogout: "匿名ログアウト済",
                AnonymousLogoutDate: firebase.firestore.FieldValue.serverTimestamp(),
            }, {merge: true}).then(function (docRef) {

                firebase.auth().signOut().then(_ => {

                    //ログアウト処理は
                    //firebase.auth().onAuthStateChangedに記述しやしたよ。
    
                },err=>{
    
                    //TODO:ログアウトエラーのときどうするべか。。
    
                });


            }).catch(function (error) {
                console.error("Error adding document: ", error);

            });
            
            
        },

        //===========================
        //ログアウト
        //===========================
        Logout(state) {
            
            firebase.auth().signOut().then(_ => {

                //ログアウト処理は
                //firebase.auth().onAuthStateChangedに記述しやしたよ。

            },err=>{

                //TODO:ログアウトエラーのときどうするべか。。

            });
        },
        SetThinks(state, items) {
            state.thinkItems = items;
        },
        SetWords(state, items) {
            state.thinkData.words = items;
        },
        RemoveThink(state, removeItem) {
            state.thinkItems.some(function (item, i) {
                if (item.id == removeItem.id) state.thinkItems.splice(i, 1); //要素を削除
            });
        },
        RemoveWord(state, removeItem) {
            state.thinkData.words.some(function (item, i) {
                if (item.id == removeItem.id) state.thinkData.words.splice(i, 1); //要素を削除
            });
        },
        SetThink(state, item) {
            state.thinkData = item;
        },
        SetLoginUser(state, item) {
            state.loginUser = item
            state.User.displayName = item.displayName;
            state.User.email = item.email;
        },
        SetUserAdditionalInformation(state, item) {
            state.User.introduction = item.introduction;
        },
        //===========================
        //Thinkタイトルを新規追加
        //===========================
        AddThink(state, newThink) {
            state.thinkItems.push(newThink);
        },
        //===========================
        //新規追加: 言葉
        //===========================
        AddWord(state, newItem) {
            state.thinkData.words.push(newItem);
        },
        increment(state) {
            state.count++
        },
        SetActiveWord(state, word) {
            state.activeWord = word;
        }
    }

})

export default store


// WEBPACK FOOTER //
// ./src/store.js